import React from "react";
import { connect } from "react-redux";
import routes from "../../../../assets/apiRoutes.json"
import axios from "axios";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  Lookup
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';
const dataTypes = [
  {
    code: 'B',
    name: 'Boolean'
  },
  {
    code: 'D',
    name: 'Date'
  },
  {
    code: 'I',
    name: 'Integer'
  },
  {
    code: 'L',
    name: 'Lookup'
  },
  {
    code: 'N',
    name: 'Number'
  },
  {
    code: 'S',
    name: 'String'
  }, 
  {
    code: 'T',
    name: 'Text'
  }
]

class InspectionAttributes extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      inspectionTypeRowId : props.data.key,
      selectedItemKeys: [],
    };

    accessToken = props.oidc.user.access_token;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.deleteRecords = this.deleteRecords.bind(this);
    this.rowInserting = this.rowInserting.bind(this);
    this.editorPreparing = this.editorPreparing.bind(this);
    this.dataSource = createStore({
      key: 'rowid',
      loadParams: { inpectionTypeRowId: this.state.inspectionTypeRowId },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.InspectionType.AllInspectionTypeAttributes}`,
      insertUrl: `${window._env_.REACT_APP_APIS}/${routes.InspectionType.InsertInspectionAttribute}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.InspectionType.UpdateInspectionAttribute}`,
      deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.InspectionType.DeleteInspectionAttribute}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }

  render() {
    return (
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
        ref={dataGrid}
        dataSource={this.dataSource}
        showBorders={true}
        className="customDataTableDesign"
        selectedRowKeys={this.state.selectedItemKeys}
        onSelectionChanged={this.selectionChanged}
        onRowInserting={this.rowInserting}
        /* onEditorPreparing={this.editorPreparing} */
        rowAlternationEnabled={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
        columnAutoWidth={true}
      >
        <Selection mode="multiple" />
        <Paging
          enabled={true}
        />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
          showInfo={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <FilterBuilderPopup position={filterBuilderPopupPosition} />
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <HeaderFilter visible={true} />
        <ColumnFixing enabled={true}/>,
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting mode="multiple"/>
        <Editing
          mode="cell"
          newRowPosition="first"
          refreshMode="repaint"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true} />
        <Column dataField="name" caption="Name"/>
        <Column dataField="description" caption="Description"/>
        <Column dataField="datatype" caption="Data Type">
          <Lookup dataSource={dataTypes} valueExpr="code" displayExpr="name" />
        </Column>
        <Column dataField="sqlscript" caption="SQL Script" /* editorOptions={{editorName:"dxTextArea", height: 200}} *//>
        <Column dataField="displayorder" caption="Display Order"></Column>
        <Toolbar>
          <Item location="before">
            <div><b>Questions</b></div>
          </Item>
          <Item name="addRowButton"/>
          <Item>
            <Button
              onClick={this.deleteRecords}
              icon="trash"
              disabled={!this.state.selectedItemKeys.length}/>
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton"/>
        </Toolbar>
      </DataGrid>
    );
  }

  
  deleteRecords()
  {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Deleting");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.InspectionType.DeleteInspectionAttributes}`,
            that.state.selectedItemKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            if (res.data.issuccess)
            {
              dataGrid.current.instance().refresh();
            }
            else
            {
              alert(res.data.errormessage, "Error");
            }
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });

  }

  selectionChanged(data) {
    this.setState({
      selectedItemKeys: data.selectedRowKeys,
    });
  }

  rowInserting(e) {
    e.data['inspectiontyperowid'] = this.state.inspectionTypeRowId;
  }

  editorPreparing(e) {
    if (e.parentType === "dataRow" && e.hasOwnProperty('dataField') && e.hasOwnProperty('editorName') && e.dataField === "sqlscript") 
    {
      e.editorName = "dxTextArea"; 
      e.editorOptions.height = 90;
    }
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(InspectionAttributes);
